/* eslint-disable no-console */
import React, { useState, useEffect, useCallback } from 'react'
import { get } from 'lodash'
import { useHistory, useParams } from 'react-router-dom'
import { sendErrorReport, displayValue, formatDate } from 'shared/helpers'
import { IconCheckmark, IconDisabled, List } from 'shared/components'
import { getCustomerAccLicenseUsers } from 'src/customer/actions'
import './styles.scss'

const LicenseUsers = () => {
  const { accountId, companyId } = useParams()
  const history = useHistory()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [usersLoading, setUsersLoading] = useState(true)
  const [users, setUsers] = useState([])
  const [usersCount, setUsersCount] = useState(0)

  const fetchUsers = useCallback(
    (companyId, accountId, tablePage = page, rows = rowsPerPage) => {
      getCustomerAccLicenseUsers(companyId, accountId, tablePage, rows)
        .then(res => {
          setUsers(get(res, 'data.results') || [])
          setUsersCount(get(res, 'data.count'))
          setUsersLoading(false)
        })
        .catch(err => {
          sendErrorReport(err, 'Cannot fetch users list')
          setUsersLoading(false)
        })
    },
    [companyId, accountId, page, rowsPerPage]
  )

  useEffect(() => {
    setUsersLoading(true)
    fetchUsers(companyId, accountId, page, rowsPerPage)
  }, [companyId, accountId, page, rowsPerPage])

  const handlePageChange = newPage => {
    setPage(newPage)
    fetchUsers(companyId, accountId, newPage, rowsPerPage)
  }

  const handlePageSizeChange = (newPageSize, newPage) => {
    setPage(newPage)
    setRowsPerPage(newPageSize)
    fetchUsers(companyId, accountId, newPage, newPageSize)
  }

  const redirectToLicenseUserPage = rowData => {
    const licenseUserID = get(rowData, 'original.id')
    history.push(`/${companyId}/license_users/${licenseUserID}`)
  }

  return (
    <div className='orders-tab'>
      <List
        clickable
        data={users || []}
        loading={usersLoading}
        minRows={2}
        handleClick={rowData => redirectToLicenseUserPage(rowData)}
        showPageSizeOptions
        pages={Math.ceil(usersCount / rowsPerPage)}
        page={page}
        onPageChange={newPage => handlePageChange(newPage)}
        pageSize={rowsPerPage}
        onPageSizeChange={(pageSize, pageIndex) => handlePageSizeChange(pageSize, pageIndex)}
        columns={[
          {
            accessor: 'created_at',
            Header: __('Created on'),
            Cell: cellInfo => formatDate(cellInfo.value),
            width: 180
          },
          {
            accessor: 'true_email',
            Header: __('Email'),
            Cell: cellInfo => displayValue(cellInfo.value),
            minWidth: 200
          },
          {
            accessor: 'first_name',
            Header: __('First Name'),
            Cell: cellInfo => displayValue(cellInfo.value),
            minWidth: 200
          },
          {
            accessor: 'last_name',
            Header: __('Last Name'),
            Cell: cellInfo => displayValue(cellInfo.value),
            minWidth: 200
          },
          {
            accessor: 'is_active',
            Header: __('Is Active'),
            Cell: cellData =>
              cellData.value ? (
                <IconCheckmark color='#10ac84' height='14px' />
              ) : (
                <IconDisabled color='red' height='14px' />
              )
          },
          {
            accessor: 'is_manager',
            Header: __('Is Manager'),
            Cell: cellData =>
              cellData.value ? (
                <IconCheckmark color='#10ac84' height='14px' />
              ) : (
                <IconDisabled color='red' height='14px' />
              )
          }
        ]}
      />
    </div>
  )
}

export default LicenseUsers
